//@ts-nocheck
// src/main.tsx
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { handleLayerVisibilityChange, setSingleTablePerH3CellMode } from './layerManager';
import { sicLetters } from './typesAndUtils';
import { MapWidget } from './MapWidget';
import { COMPANY_FILES } from './companyFiles';
import { loadAndStoreTables } from './tableManager';

const testMode = false;

const companyFiles = testMode
  ? ['202504112139_83195cfffffffff_brotli.parquet', '202504112139_83194afffffffff_brotli.parquet']
  : COMPANY_FILES;

const initialViewState = {
  longitude: -2.7,
  latitude: 54.3,
  zoom: 5.3,
  maxZoom: 18,
  pitch: 0,
  bearing: 0,
};

function App() {
  useEffect(() => {
    const loadingDiv = document.createElement('div');
    loadingDiv.id = 'loading-message';
    loadingDiv.style.position = 'absolute';
    loadingDiv.style.bottom = '10px';
    loadingDiv.style.left = '10px';
    loadingDiv.style.background = '#1a2a6c';
    loadingDiv.style.padding = '8px 16px';
    loadingDiv.style.borderRadius = '12px';
    loadingDiv.style.zIndex = '1000';
    loadingDiv.style.fontFamily = "'Poppins', sans-serif";
    loadingDiv.style.fontSize = '24px';
    loadingDiv.style.fontWeight = '600';
    loadingDiv.style.color = '#fff';
    loadingDiv.style.textShadow = '0 0 4px rgba(255, 255, 255, 0.8)';
    loadingDiv.style.width = '260px'; // Match industry panel
    loadingDiv.className = 'shine-text';
    loadingDiv.style.display = 'none';
    document.body.appendChild(loadingDiv);

    async function initialize() {
      try {
        await loadAndStoreTables(companyFiles, (isLoading, progress = 0, total = 0) => {
          if (isLoading) {
            loadingDiv.textContent = `Loading ${progress} of ${total} files...`;
            loadingDiv.style.display = 'block';
          } else {
            loadingDiv.style.display = 'none';
          }
        });
        await handleLayerVisibilityChange(["*"], initialViewState);
      } catch (error) {
        console.error('Initialization error:', error);
        loadingDiv.style.display = 'none';
      }
    }

    initialize();

    return () => {
      if (document.body.contains(loadingDiv)) {
        document.body.removeChild(loadingDiv);
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <MapWidget
        sicLetters={sicLetters}
        isDataLoading={false}
      />
      <style>
        {`
          .shine-text {
            animation: shine 1.5s ease-in-out 1; /* Run once */
          }
          @keyframes shine {
            0% { text-shadow: 0 0 4px rgba(255, 255, 255, 0.8); }
            50% { text-shadow: 0 0 8px rgba(255, 255, 255, 1); }
            100% { text-shadow: 0 0 4px rgba(255, 255, 255, 0.8); }
          }
        `}
      </style>
    </div>
  );
}

const container = document.getElementById('root');
if (!container) throw new Error('No root element found');
createRoot(container).render(<App />);